/**
 * useBodyScrollLock Hook
 * 
 * Locks body scroll when a component is active (e.g., modal or sidebar open).
 * Automatically restores scroll on unmount or when locked state changes.
 * 
 * @param isLocked - Whether scroll should be locked
 * 
 * @example
 * const [isMenuOpen, setIsMenuOpen] = useState(false);
 * useBodyScrollLock(isMenuOpen);
 */

import { useEffect } from "react";

export function useBodyScrollLock(isLocked: boolean) {
    useEffect(() => {
        if (isLocked) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [isLocked]);
}
